// import React from "react";
// import { useNavigate } from "react-router-dom";
// import "./CartPage.css";
// import { useAuth } from "../context/AuthContext";

// const CartPage = ({ cartItems, onUpdateQuantity, onRemove }) => {
//   const navigate = useNavigate();
//   const { user } = useAuth();
//   const subtotal = cartItems.reduce(
//     (sum, item) => sum + item.price * item.quantity,
//     0
//   );
//   const shipping = subtotal > 999 ? 0 : 99;
//   const total = subtotal + shipping;

//   if (cartItems.length === 0) {
//     return (
//       <div className="cart-page">
//         <div className="container">
//           <div className="empty-cart">
//             <div className="empty-cart-icon">🛒</div>
//             <h2 className="empty-cart-title">Your Cart is Empty</h2>
//             <p className="empty-cart-text">
//               Looks like you haven't added anything to your cart yet
//             </p>
//             <button
//               className="shop-now-button"
//               onClick={() => navigate("/products")}
//             >
//               Start Shopping
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="cart-page">
//       <div className="cart-header">
//         <div className="container">
//           <h1 className="page-title">Shopping Cart</h1>
//           <p className="page-subtitle">
//             {cartItems.length} {cartItems.length === 1 ? "item" : "items"} in
//             your cart
//           </p>
//         </div>
//       </div>

//       <div className="cart-content">
//         <div className="container">
//           <div className="cart-layout">
//             <div className="cart-items">
//               {cartItems.map((item) => (
//                 <div
//                   key={`${item.id}-${item.selectedSize}`}
//                   className="cart-item"
//                 >
//                   <img
//                     src={item.images[0]?.url}
//                     alt={item.name}
//                     className="cart-item-image"
//                   />

//                   <div className="cart-item-details">
//                     <h3 className="cart-item-name">{item.name}</h3>
//                     <p className="cart-item-size">Size: {item.selectedSize}</p>
//                     <p className="cart-item-price">
//                       ₹{item.price.toLocaleString()}
//                     </p>

//                     <div className="cart-item-quantity">
//                       <button
//                         className="quantity-button"
//                         onClick={() =>
//                           onUpdateQuantity(
//                             item.id,
//                             item.selectedSize,
//                             Math.max(1, item.quantity - 1)
//                           )
//                         }
//                       >
//                         −
//                       </button>
//                       <span className="quantity-display">{item.quantity}</span>
//                       <button
//                         className="quantity-button"
//                         onClick={() =>
//                           onUpdateQuantity(
//                             item.id,
//                             item.selectedSize,
//                             item.quantity + 1
//                           )
//                         }
//                       >
//                         +
//                       </button>
//                     </div>
//                   </div>

//                   <div className="cart-item-actions">
//                     <p className="cart-item-total">
//                       ₹{(item.price * item.quantity).toLocaleString()}
//                     </p>
//                     <button
//                       className="remove-button"
//                       onClick={() => onRemove(item.id, item.selectedSize)}
//                       title="Remove item"
//                     >
//                       🗑️
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             <div className="cart-summary">
//               <h3 className="summary-title">Order Summary</h3>

//               <div className="summary-details">
//                 <div className="summary-row">
//                   <span>Subtotal</span>
//                   <span className="summary-value">
//                     ₹{subtotal.toLocaleString()}
//                   </span>
//                 </div>
//                 <div className="summary-row">
//                   <span>Shipping</span>
//                   <span
//                     className={`summary-value ${shipping === 0 ? "free" : ""}`}
//                   >
//                     {shipping === 0 ? "FREE" : `₹${shipping}`}
//                   </span>
//                 </div>

//                 {subtotal < 999 && (
//                   <div className="shipping-notice">
//                     Add ₹{(999 - subtotal).toLocaleString()} more for free
//                     shipping!
//                   </div>
//                 )}
//               </div>

//               <div className="summary-total">
//                 <span className="total-label">Total</span>
//                 <span className="total-value">₹{total.toLocaleString()}</span>
//               </div>

//               <button
//                 className="checkout-button"
//                 onClick={() => {
//                   console.log(cartItems, "cartItems");
//                   if (cartItems.length > 0)
//                     localStorage.setItem("cart", JSON.stringify(cartItems));
//                   if (user) return navigate("/checkout");
//                   // else return navigate("/login");
//                 }}
//               >
//                 Proceed to Checkout
//               </button>

//               <button
//                 className="continue-shopping"
//                 onClick={() => navigate("/products")}
//               >
//                 Continue Shopping
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CartPage;
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./CartPage.css";
import { useAuth } from "../context/AuthContext";
import settingService from "../services/settingService";

const CartPage = ({ cartItems, onUpdateQuantity, onRemove }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [loadingSettings, setLoadingSettings] = useState(true);

  const subtotal = cartItems.reduce((sum, item) => {
    const price =
      item.offerPrice && item.offerPrice < item.price
        ? item.offerPrice
        : item.price;
    return sum + price * item.quantity;
  }, 0);

  useEffect(() => {
    fetchDeliveryFee();
  }, [subtotal]);

  const fetchDeliveryFee = async () => {
    try {
      setLoadingSettings(true);
      const response = await settingService.getSettings();

      if (response?.success) {
        const deliveryFees = response.data.deliveryFees || [];

        // Find matching delivery fee based on subtotal
        const matchingFee = deliveryFees.find(
          (fee) =>
            fee.isActive &&
            subtotal >= fee.minAmount &&
            subtotal <= fee.maxAmount
        );

        setDeliveryFee(matchingFee ? matchingFee.fee : 0);
      }
    } catch (error) {
      console.error("Error fetching delivery fee:", error);
      setDeliveryFee(0);
    } finally {
      setLoadingSettings(false);
    }
  };

  const total = subtotal + deliveryFee;

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="container">
          <div className="empty-cart">
            <div className="empty-cart-icon">🛒</div>
            <h2 className="empty-cart-title">Your Cart is Empty</h2>
            <p className="empty-cart-text">
              Looks like you haven't added anything to your cart yet
            </p>
            <button
              className="shop-now-button"
              onClick={() => navigate("/products")}
            >
              Start Shopping
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-header">
        <div className="container">
          <h1 className="page-title">Shopping Cart</h1>
          <p className="page-subtitle">
            {cartItems.length} {cartItems.length === 1 ? "item" : "items"} in
            your cart
          </p>
        </div>
      </div>

      <div className="cart-content">
        <div className="container">
          <div className="cart-layout">
            <div className="cart-items">
              {cartItems.map((item) => (
                <div
                  key={`${item.id}-${item.selectedSize}`}
                  className="cart-item"
                >
                  <img
                    src={item.images[0]?.url}
                    alt={item.name}
                    className="cart-item-image"
                  />

                  <div className="cart-item-details">
                    <h3 className="cart-item-name">{item.name}</h3>
                    <p className="cart-item-size">Size: {item.selectedSize}</p>
                    <div className="cart-item-price">
                      {item.offerPrice && item.offerPrice < item.price ? (
                        <>
                          <span className="offer-price">
                            ₹{item.offerPrice.toLocaleString()}
                          </span>
                          <span className="original-price">
                            ₹{item.price.toLocaleString()}
                          </span>
                        </>
                      ) : (
                        <span>₹{item.price.toLocaleString()}</span>
                      )}
                    </div>

                    <div className="cart-item-quantity">
                      <button
                        className="quantity-button"
                        onClick={() =>
                          onUpdateQuantity(
                            item.id,
                            item.selectedSize,
                            Math.max(1, item.quantity - 1)
                          )
                        }
                      >
                        −
                      </button>
                      <span className="quantity-display">{item.quantity}</span>
                      <button
                        className="quantity-button"
                        onClick={() =>
                          onUpdateQuantity(
                            item.id,
                            item.selectedSize,
                            item.quantity + 1
                          )
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div className="cart-item-actions">
                    <div className="cart-item-total">
                      {item.offerPrice && item.offerPrice < item.price ? (
                        <>
                          <span className="offer-total">
                            ₹
                            {(item.offerPrice * item.quantity).toLocaleString()}
                          </span>
                          <span className="original-total">
                            ₹{(item.price * item.quantity).toLocaleString()}
                          </span>
                        </>
                      ) : (
                        <span>
                          ₹{(item.price * item.quantity).toLocaleString()}
                        </span>
                      )}
                    </div>
                    <button
                      className="remove-button"
                      onClick={() => onRemove(item.id, item.selectedSize)}
                      title="Remove item"
                    >
                      🗑️
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className="cart-summary">
              <h3 className="summary-title">Order Summary</h3>

              <div className="summary-details">
                <div className="summary-row">
                  <span>Subtotal</span>
                  <span className="summary-value">
                    ₹{subtotal.toLocaleString()}
                  </span>
                </div>
                <div className="summary-row">
                  <span>Shipping</span>
                  <span
                    className={`summary-value ${
                      deliveryFee === 0 ? "free" : ""
                    }`}
                  >
                    {deliveryFee === 0 ? "FREE" : `₹${deliveryFee}`}
                  </span>
                </div>
              </div>

              <div className="summary-total">
                <span className="total-label">Total</span>
                <span className="total-value">₹{total.toLocaleString()}</span>
              </div>

              <button
                className="checkout-button"
                onClick={() => {
                  if (cartItems.length > 0)
                    localStorage.setItem("cart", JSON.stringify(cartItems));
                  let us = localStorage.getItem("user");
                  let token = localStorage.getItem("token");

                  console.log(us, token, "user in cart");
                  if (!us || !token) return navigate("/login");
                  if (user) return navigate("/checkout");
                }}
              >
                Proceed to Checkout
              </button>

              <button
                className="continue-shopping"
                onClick={() => navigate("/products")}
              >
                Continue Shopping
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
